import { Bounce, toast } from "react-toastify";
import { createPaypalOrder, createRazorpayOrder, createStripeCheckoutSession, getIsUserLoggedIn, verifyRazorpayPayment } from "../Api/api";
import { ANALYTICS_EVENTS, CAN_PLAY_ACTION, DEVICE_ACCESS_CONTROL, DISPLAYPLATFORM, LOCAL_STORAGE_KEY, MEDIACATEGORIES, OTT_POSTER_TYPE, OTTROUTETYPE, RAILTYPE, VODTYPE } from "../constant";
import { loadStripe } from "@stripe/stripe-js";
import * as API from '../Api/api';
import AnalyticsManager from "../analytics/analyticsManager";

export const utility = {};

utility.getValue = function (key) {
    return JSON.parse(localStorage.getItem(key));
};


utility.setValue = function (key, value) {

    if (value == undefined) {
        value = null;
    }

    localStorage.setItem(key, JSON.stringify(value));
};

utility.deleteValue = function (key) {
    localStorage.removeItem(key);
};

utility.clearLocalStorage = function () {
    localStorage.clear();
};

utility.getPosterUrl = (posters, posterType) => {

    if (!posters || typeof posters == 'string' || posters.length == 0) {
        return ""
    }

    var poster = posters.find((x) => x?.OttPosterType?.SID == posterType);

    return poster ? poster.Url : posters[0].Url

}

utility.getValidPosterFromRail = (railType) => {
    switch (railType) {
        case RAILTYPE.Rail:
            return OTT_POSTER_TYPE.Portrait;
        case RAILTYPE.CircleRail:
            return OTT_POSTER_TYPE.Circle;
        case RAILTYPE.PotraitRail:
            return OTT_POSTER_TYPE.Portrait;
        case RAILTYPE.LandscapeRail:
            return OTT_POSTER_TYPE.Landscape;
        case RAILTYPE.SquareRail:
            return OTT_POSTER_TYPE.Square;
        default:
            return OTT_POSTER_TYPE.Free;
    }
}

utility.getMediaCategoryType = (value) => {
    switch (value) {
        case 0:
            return "";
        case 1:
            return "Program";
        case 2:
            return "Episode";
        case 3:
            return "Movie";
        case 4:
            return "Interstitial";
        case 5:
            return "Commercial";
        case 6:
            return "Filler";
        case 7:
            return "Music";
        case 8:
            return "Series";
        case 9:
            return "Season";
        case 10:
            return "Trailer";
        default:
            return "";
    }
}

utility.formatMilliseconds = (milliseconds) => {
    var hours = Math.floor(milliseconds / 1000 / 60 / 60);
    var minutes = Math.floor((milliseconds / 1000 / 60 / 60 - hours) * 60);
    return hours + "h " + minutes + "m ";
}

utility.onAssetClick = async (asset, ottSetting, navigate, displayPlatform) => {

    let selectedAsset = asset;
    const isMobile = displayPlatform == DISPLAYPLATFORM.MOBILE ? true : false;
    const isWeb = displayPlatform == DISPLAYPLATFORM.WEB ? true : false;

    let user = utility.getValue(LOCAL_STORAGE_KEY.user);
    const isFree = asset.VodTypes?.SID ? asset.VodTypes?.SID == VODTYPE.FREE : false;
    
    if (ottSetting?.deviceAccessControl == DEVICE_ACCESS_CONTROL.Login) {

        //case 1 if user is not logged in
        if (!user) {
            if (isWeb) {
                navigate('/loginWeb')
            } else {
                navigate('/login');
            }
            return;
        }

        // case 2 check device limit

        let isUserLoggedInAndHasPaymentPlan = await getIsUserLoggedIn(user?._id, asset);
        if (isUserLoggedInAndHasPaymentPlan.data.action == CAN_PLAY_ACTION.VALID) {
            user.PaymentPlan = isUserLoggedInAndHasPaymentPlan.data.activePlans;
            utility.setValue(LOCAL_STORAGE_KEY.user, user);
        }

        if (isUserLoggedInAndHasPaymentPlan.data.action == CAN_PLAY_ACTION.DEVICE_LIMIT_EXCEED && !isFree) {
            toast('Device removed. Please login again.', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
                transition: Bounce,
            });
            utility.setValue(LOCAL_STORAGE_KEY.user, null);
            if (isWeb) {
                navigate('/loginWeb')
            } else {
                navigate('/login');
            }
            return;
        }
        // case 3 if no plan present
        if (isUserLoggedInAndHasPaymentPlan.data.action == CAN_PLAY_ACTION.UPGRADE && !isFree) {
            toast(isUserLoggedInAndHasPaymentPlan.message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
                transition: Bounce,
            });
            navigate(isWeb ? '/plansweb' : '/plans');
            return;
        }
    }

    //handle series
    let seriesFirstEpisode = await setSeriesData(asset);
    console.log(seriesFirstEpisode);

    if (seriesFirstEpisode != null) {
        // if series is selected, then first episode will be played
        asset = seriesFirstEpisode;
    }
    const canPlay = isFree || utility.getValue(LOCAL_STORAGE_KEY.user)?.PaymentPlan?.length > 0 ? true : false ?? false;

    if (selectedAsset.MediaCategory == MEDIACATEGORIES.Episode) {
        selectedAsset.routeType = OTTROUTETYPE.Player
    }

    console.log(canPlay);
    console.log(asset.routeType);
    switch (selectedAsset.routeType) {
        case OTTROUTETYPE.Page:
            var pages = utility.getValue('pages');
            var page_id = asset.page_id;
            let page = pages.find(p => p._id === page_id);
            if (page) {
                navigate(isMobile ? '/mobile' : '/', { state: { page: page } })
            }
            break;
        case OTTROUTETYPE.Player:
            if (canPlay) {
                utility.onPlay(asset, navigate);
            }
            break;
        case OTTROUTETYPE.PI_Page:
            navigate('/' + (isWeb ? '' : isMobile ? 'mobile/' : 'tv/') + selectedAsset.Title.toString().replace(' ', '_'), { state: { asset: selectedAsset, ottSetting: ottSetting, isOpenPiPage: true } })
            break;
        default:
            if (canPlay) {
                utility.onPlay(asset, navigate);
            }
            break;
    }
}




const setSeriesData = async (asset = {}, seasonNo = null) => {
    console.log(asset);

    if (asset.MediaCategory == MEDIACATEGORIES.Series || asset.MediaCategory == MEDIACATEGORIES.Season || asset.MediaCategory == MEDIACATEGORIES.Episode) {

        let localSeriesRes = await API.getSeries(asset);
        let localSeries = (localSeriesRes?.success && localSeriesRes?.data.length > 0) ? localSeriesRes.data : [];
        console.log(localSeries);

        if (localSeries != null && localSeries.length > 0) {
            // sortby seasonNo
            localSeries = localSeries.sort((a, b) => a.SeasonNo - b.SeasonNo);
            console.log(localSeries);

            let selectedSeries = seasonNo != null ? localSeries.find((s) => s.SeasonNo == seasonNo) : localSeries[localSeries.length - 1];
            console.log(selectedSeries);

            if (selectedSeries != null) {
                let episodeIndex = asset?.MediaCategory == MEDIACATEGORIES.Episode ? selectedSeries.Episodes.findIndex(e => e._id == asset._id) : 0
                utility.setValue(LOCAL_STORAGE_KEY.selectedSeriesEpisodes, selectedSeries.Episodes);
                utility.setValue(LOCAL_STORAGE_KEY.selectedEpisodeIndex, episodeIndex);

                if (selectedSeries?.Episodes?.length > 0) {
                    return selectedSeries.Episodes[episodeIndex];
                }


            }

        }

    }

    utility.setValue(LOCAL_STORAGE_KEY.selectedSeriesEpisodes, null);
    return null;
}

utility.onPlay = (asset, navigate) => {
    // Analytics event
    console.log(asset);
    
    let selectedSeries = utility.getValue(LOCAL_STORAGE_KEY.selectedSeriesEpisodes);
    if (asset.MediaCategory == MEDIACATEGORIES.Series || asset.MediaCategory == MEDIACATEGORIES.Season) {
        if (selectedSeries != null && selectedSeries.length > 0) {
            asset = selectedSeries[0];
        }

    }

    AnalyticsManager().logEvent(ANALYTICS_EVENTS.CONTENT_PLAY, asset);
    navigate('/liveTv', { state: { asset: asset } });
}

utility.onPlayNextEpisode = (navigate) => {
    const selectedSeries = utility.getValue(LOCAL_STORAGE_KEY.selectedSeriesEpisodes);
    const selectedEpisodeIndex = utility.getValue(LOCAL_STORAGE_KEY.selectedEpisodeIndex);

    if (selectedSeries && selectedEpisodeIndex != null && selectedEpisodeIndex >= 0) {
        const newIndex = selectedEpisodeIndex + 1;
        if (newIndex >= selectedSeries.length) {
            return;
        }

        utility.setValue(LOCAL_STORAGE_KEY.selectedEpisodeIndex, newIndex);
        const asset = selectedSeries[newIndex];
        utility.onPlay(asset, navigate);
    } else {
        console.log("Error: onPlayNextEpisode");
    }
}

utility.isShowingNextEpisode = () => {
    const selectedSeries = utility.getValue(LOCAL_STORAGE_KEY.selectedSeriesEpisodes);
    const selectedEpisodeIndex = utility.getValue(LOCAL_STORAGE_KEY.selectedEpisodeIndex);
    return selectedSeries && selectedEpisodeIndex != null && selectedEpisodeIndex >= 0 && selectedEpisodeIndex < selectedSeries.length - 1;
}

utility.loadRazorpayScript = () =>
    new Promise((resolve) => {
        if (document.querySelector("#razorpay-script")) return resolve(true);

        const script = document.createElement("script");
        script.id = "razorpay-script";
        script.src = "https://checkout.razorpay.com/v1/checkout.js";
        script.onload = () => resolve(true);
        script.onerror = () => resolve(false);
        document.body.appendChild(script);
    });

utility.openRazorpay = async ({ amount, currencyCode = "INR", userID, plan, onSuccess, onFailure, }) => {
    const loaded = await utility.loadRazorpayScript();
    let user = utility.getValue(LOCAL_STORAGE_KEY.user);
    console.log(user);
    console.log(loaded);
    if (!loaded) return onFailure("Razorpay SDK failed to load");

    try {
        const result = await createRazorpayOrder({ amount, currencyCode, userID, plan });
        console.log(result);
        if (!result.success) return onFailure(result.message);

        const { orderID, amount: Amount, currency, keyID } = result.data;

        const options = {
            key: keyID,
            amount: Amount,
            currency,
            name: "Web OTT",
            description: plan?.Description || "Subscription Plan",
            order_id: orderID,
            handler: async (response) => {
                const verifyResult = await verifyRazorpayPayment(response);
                verifyResult.success
                    ? onSuccess(response)
                    : onFailure("Payment verification failed");
            },
            modal: {
                ondismiss: () => {
                    onFailure("Payment was not completed");
                }
            },
            theme: { color: "#007bff" },
            method: {
                netbanking: true,
                card: true,
                upi: true,
                wallet: true,
            },
            prefill: {
                name: user?.Name,
                email: user?.Email,
                contact: user?.RMN
            },
        };
        const rzp = new window.Razorpay(options);
        rzp.open();
    } catch (err) {
        onFailure("Payment error occurred");
    }
};


utility.openStripe = async ({ amount, currencyCode, userID, plan
}) => {
    try {
        const response = await createStripeCheckoutSession({ amount, currencyCode, plan, userID });
        if (!response.success) {
            throw new Error(response.message || "Session creation failed");
        }
        console.log(response);
        const stripe = await loadStripe(response.key);
        await stripe.redirectToCheckout({ sessionId: response.sessionId });
    } catch (err) {
        console.error("Stripe Checkout Error:", err.message);
    }
};

utility.openPaypal = async ({ amount, currencyCode, plan, userID }) => {
    try {
        const response = await createPaypalOrder({ amount, currencyCode, plan, userID });
        console.log(response);

        if (!response.success) throw new Error(response.message);

        window.location.href = response.approveUrl;

    } catch (err) {
        console.error("PayPal payment error:", err);
    }
};


utility.loadVTTThumbnails = async (vttUrl) => {
    try {
        const response = await fetch(vttUrl);
        const vttText = await response.text();
        
        const thumbnails = [];
        const lines = vttText.split('\n');
        
        for (let i = 0; i < lines.length; i++) {
            const line = lines[i].trim();
            if (line.includes(' --> ')) {
                const [startTime] = line.split(' --> ');
                const url = lines[i + 1]?.trim();
                if (url && url.startsWith('http')) {
                    const timeInSeconds = utility.parseVTTTime(startTime);
                    thumbnails.push({ time: timeInSeconds, url });
                }
            }
        }
        
        return thumbnails;
    } catch (error) {
        console.error('Failed to load VTT thumbnails:', error);
        return [];
    }
};

utility.parseVTTTime = (timeStr) => {
    const parts = timeStr.split(':');
    if (parts.length === 2) {
        const [minutes, seconds] = parts;
        return parseInt(minutes) * 60 + parseFloat(seconds);
    }
    return 0;
};
